<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >

    <div>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :rowSelection="{ onChange: selectRowsChange, selectedRowKeys }"
        bordered

      >

        <Dict slot="allowDiferTime" slot-scope="text" :dict-code="DICT_CODE.ALLOW_DIFER_TIME" :value="text"/>
        <template slot="allowPrepay" slot-scope="text">
          {{ text == 0 ? 'Not Allowed' : 'Allowed' }}
        </template>

      </a-table>
    </div>

  </a-modal>
</template>

<script>

import {editRiskRule, riskFeaturesList, addRiskRule} from '@/webpublicapi/risk'
import { cloneDeep } from 'lodash';

// duplicateCheck
export default {
  name: 'riskRuleModal',
  data() {
    return {
      dataSource: [],
      loading: false,
      featuresId: undefined,
      selectedRowKeys: [],
      columns: [
        {
          title: 'ID',
          align: 'center',
          dataIndex: 'id'
        },
        {
          title: 'Rule Code',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: 'RuleDefaultValue',
          align: 'center',
          dataIndex: 'defaultValue'
        },
        {
          title: 'Description',
          align: 'center',
          dataIndex: 'intro'
        },
        {
          title: 'YesNoDelete',
          align: 'center',
          dataIndex: 'isDel'
        }
      ],
      title: 'Action',
      visible: false,
      screenWidth: 1200,
      model: {},
      proId: '',
    }
  },
  created() {
  },
  methods: {
    loadData() {
      this.loading = true;
      this.selectedRowKeys = [];
      riskFeaturesList().then((res) => {
        if (res.code === 1000) {
          this.dataSource = res.data
        } else {
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    selectRowsChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.originSelectedList = selectedRows;
      this.selectedList = cloneDeep(selectedRows);
    },
    add(proId) {
      this.proId = proId;
      this.edit({})
    },
    edit(record) {
      this.visible = true;
      this.loadData()
    },

    // Confirm
    handleOk() {

      const formData = {idList: this.selectedRowKeys, strategyId: this.proId}
      addRiskRule(formData).then((res) => {
        if (res.code === 1000) {
          that.$message.success(res.msg)
          that.$emit('ok')
          this.close()
        } else {
          that.$message.warning(res.msg)
        }
      })

    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    }
  }
}
</script>
